export const SCREEN_THRESHOLD = 756;


// WEBPACK FOOTER //
// ./src/global/constants.js